import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Col, Container, Row } from "react-bootstrap";

import Loading from "../../loading/pages/Loading";
import Failed from "../../loading/pages/Failed";
import { getRequest } from "../../api/axiosRequests";
import { useAuth } from "../../auth/hook";
import CardExercise from "../components/CardExercise";
import { PALETTE } from "../../common/ThemeConstants";
import ExercisesHeader from "../components/ExercisesHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { useWindowWidth } from "../../api/useWindowWidth";

export default function Exercises() {
  const navigate = useNavigate();
  const [windowWidth, isMobile] = useWindowWidth();
  const [exercises, setExercises] = useState([]);
  const [filteredExercises, setFilteredExercises] = useState([]);
  const auth = useAuth();
  const userSubscription = auth.userSubscription;
  const [hasPermission, setHasPermission] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const margin = 40;
  const mobileCardWidth = (windowWidth - margin) / 2;
  const mobileCardHeight = mobileCardWidth * 1.25;

  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = exercises.filter((ex) =>
      ex.name.toLowerCase().includes(nameLowerCase)
    );
    setFilteredExercises(filtered);
  };


  useEffect(() => {
    const fetchData = () => {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const promise1 = getRequest("exerciseList/", headers);
      const promise2 = getRequest("userData/", headers);

      Promise.all([promise1, promise2])
        .then((values) => {
          const exerciseList = values[0]["data"];
          const role = values[1]["data"]["role"];
          setHasPermission(role === "Admin" || userSubscription.id != -1);
          setExercises(exerciseList);
          setFilteredExercises(exerciseList);
          setIsFailed(false);
          setIsLoaded(true);
        })
        .catch((err) => {
          setIsFailed(true);
          setIsLoaded(true);
        });
    };

    window.scrollTo(0, 0);
    fetchData();
  }, []);

  return (
    <div>
      <ExercisesHeader
        onSearchChange={onSearchChange}
        disabled={!hasPermission}
      />
      <ContainerResponsive>
        {!isLoaded && <Loading />}
        {isLoaded && isFailed && (
          <Failed
            separatorText={""}
            mainDescription={"Errore durante il caricamento degli esercizi."}
          />
        )}
        {isLoaded && !isFailed && (
          <div>
            <Container className="mt-2">
              <h3 className="text-start px-1">
                {hasPermission
                  ? "Tutti gli esercizi"
                  : "Tutti gli esercizi"}
              </h3>
              <p className="text-start px-1" style={{ color: PALETTE.GRAY }}>
                {hasPermission
                  ? "Visualizza la spiegazione tecnica di tutti gli esercizi disponibili."
                  : "Passa a Premium per visualizzare i tutorial di tutti gli esercizi."}
              </p>
            </Container>
            <Container className="mb-3">
              <Row className="m-auto p-0" style={{ width: "100%" }}>
                {filteredExercises.length > 0 &&
                  filteredExercises.map((exercise, idxExercise) => (
                    <Col
                      key={idxExercise}
                      className="text-center align-self-center p-0 mx-1 my-1"
                      style={{
                        minWidth: isMobile ? mobileCardWidth : 180,
                        maxWidth: isMobile ? mobileCardWidth : 180,
                        width: isMobile ? mobileCardWidth : 180,
                        height: isMobile ? mobileCardHeight : 225,
                      }}
                    >
                      <CardExercise
                        height={isMobile ? mobileCardHeight : 225}
                        exercise={exercise}
                        isActive={hasPermission}
                        to={hasPermission ? `/exercise/${exercise.id}/Content` : "/subscriptions"}
                      />
                    </Col>
                  ))}
                {filteredExercises.length === 0 && (
                  <div className="pt-5">
                    <Failed
                      separatorText={""}
                      mainDescription={`Nessun esercizio trovato.`}
                      secondaryDescription={""}
                      paddingTop={"0px"}
                    />
                  </div>
                )}
              </Row>
            </Container>
            {filteredExercises.length > 0 && !hasPermission && (
              <div
                className="m-auto rounded-pill"
                style={{ width: "96%", bottom: 100, position: "fixed", left: "2%", background: PALETTE.LIGHTGRAY }}
              >
                <Container
                  onClick={() => navigate("/subscriptions")}
                  className="rounded-pill shadow m-auto p-1"
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    textAlign: "center",
                    background: PALETTE.GRADIENT,
                    zIndex: 100,
                  }}
                >
                  <div
                    className="text-center align-self-center"
                    style={{
                      paddingTop: 15,
                      paddingBottom: 15,
                      color: PALETTE.WHITE,
                      borderRadius: 16,
                    }}
                  >
                    <span>Passa a Premium</span>
                  </div>
                </Container>
              </div>
            )}
          </div>
        )}
      </ContainerResponsive>
    </div>
  );
}
